/**
 * STANSER — Widget de Compatibilidad Hypertherm Powermax
 * assets/stanser-compatibility.js
 * Versión: 1.9 | 2026-04-28 — UX fix: badge "Exclusivo" para partes de 1 máquina (125A/105A). Mejor mensaje cuando part no encontrado. v1.8: DB 100% VERIFIED.
 * v1.6 — +6 partes nuevas [VERIFIED]: 420415·420542 marking, 220948 ohmic FineCut, 420480·420419 gouging max control, 420580 ohmic ring SYNC. DB: 64 partes.
 * Benchmark: Hypertherm.com usa lista visual. Baymard: catálogos ≤9 ítems → lista > dropdown.
 * CNC Pierce Fix: pierce = capacidad CNC mecanizado (limitante real). rec = corte desde orilla solamente.
 *
 * Dependencia: snippets/stanser-compatibility-widget.liquid
 * Metafield requerido: product.metafields.custom.hypertherm_part_number
 */

(function() {
  'use strict';

  /* ============================================================
     BASE DE DATOS DE COMPATIBILIDAD
     Fuente: Research OS F6 + Portal Hypertherm Distribuidor [VERIFIED]
     AUDIT F8 2026-04-28: Serie SYNC solo 45/65/85/105. NO existe PM125 SYNC. PM125 es 100% Duramax Hyamp.
     Ningún consumible de 45-105A es intercambiable con el 125A
  ============================================================ */
  var STANSER_COMPAT = {
    machines: {
      pm45xp:   { name: 'Powermax 45 XP',    short: 'PM 45 XP',   amps: 45,  torch: 'Duramax Lock', series: 'legacy', rec: 16, quality: 22, sever: 29, pierce: 12 },
      pm65:     { name: 'Powermax 65',        short: 'PM 65',       amps: 65,  torch: 'Duramax',      series: 'legacy', rec: 20, quality: 25, sever: 32, pierce: 16 },
      pm85:     { name: 'Powermax 85',        short: 'PM 85',       amps: 85,  torch: 'Duramax',      series: 'legacy', rec: 25, quality: 32, sever: 38, pierce: 20 },
      pm105:    { name: 'Powermax 105',       short: 'PM 105',      amps: 105, torch: 'Duramax',      series: 'legacy', rec: 32, quality: 38, sever: 50, pierce: 22 },
      pm125:    { name: 'Powermax 125',       short: 'PM 125',      amps: 125, torch: 'Duramax Hyamp',series: 'legacy', rec: 38, quality: 44, sever: 57, pierce: 25 },
      pm45sync: { name: 'Powermax 45 SYNC',   short: 'PM 45 SYNC',  amps: 45,  torch: 'SmartSYNC',   series: 'sync',   rec: 16, quality: 22, sever: 29, pierce: 12 },
      pm65sync: { name: 'Powermax 65 SYNC',   short: 'PM 65 SYNC',  amps: 65,  torch: 'SmartSYNC',   series: 'sync',   rec: 20, quality: 25, sever: 32, pierce: 16 },
      pm85sync: { name: 'Powermax 85 SYNC',   short: 'PM 85 SYNC',  amps: 85,  torch: 'SmartSYNC',   series: 'sync',   rec: 25, quality: 32, sever: 38, pierce: 20 },
      pm105sync:{ name: 'Powermax 105 SYNC',  short: 'PM 105 SYNC', amps: 105, torch: 'SmartSYNC',   series: 'sync',   rec: 32, quality: 38, sever: 50, pierce: 22 },
    },

    // Mapa de compatibilidad por número de parte
    // 'ok' = compatible nativo | 'adapter' = compatible con adaptador 428951 | 'no' = incompatible | 'gap' = desconocido
    parts: {
      /* ── ELECTRODOS ── */
      '220842': {
        type: 'Electrodo Standard', note_ok: 'Para corte manual y mecanizado.',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa electrodo exclusivo 220971 (Duramax Hyamp). Los equipos SYNC usan cartuchos all-in-one, no piezas separadas.',
        kit: { manual: ['220818','220854','220857'], mechanized: ['220817','220953','220857'] }
      },
      '220777': {
        type: 'Electrodo CopperPlus (vida extendida)', note_ok: 'Para corte manual y mecanizado. Duración extendida ~50% vs estándar.',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa electrodo exclusivo 220971 (Duramax Hyamp). Los equipos SYNC usan cartuchos all-in-one, no piezas separadas.',
        kit: { manual: ['220818','220854','220857'], mechanized: ['220817','220953','220857'] }
      },

      /* ── BOQUILLAS ── */
      '220941': {
        type: 'Boquilla 45A',
        pm45xp:'ok', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Esta boquilla es específica para 45A legacy. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Boquilla de 45 amperios.',
        kit: {}
      },
      '220819': {
        type: 'Boquilla 65A',
        pm45xp:'no', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Esta boquilla es específica para 65-85A legacy. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Boquilla de 65A — compatible también con Powermax 85 a menor amperaje.',
        kit: {}
      },
      '220816': {
        type: 'Boquilla 85A',
        pm45xp:'no', pm65:'no', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Esta boquilla es específica para 85A legacy. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Boquilla específica para 85 amperios.',
        kit: {}
      },
      '220990': {
        type: 'Boquilla 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Esta boquilla es exclusiva del Powermax 105A legacy. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Boquilla específica para 105 amperios. Familia de consumibles distinta a 65/85.',
        kit: {}
      },

      /* ── ESCUDOS ── */
      '220818': {
        type: 'Escudo Manual',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM105 usa escudo específico 220992. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Para corte MANUAL solamente. Para mecanizado CNC usar escudo 220817 o 220955.',
        kit: {}
      },
      '220817': {
        type: 'Escudo Mecanizado Standard',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM105 usa escudo mecanizado específico 220993. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Para corte MECANIZADO CNC solamente. Para corte manual usar escudo 220818.',
        kit: {}
      },
      '220955': {
        type: 'Escudo Mecanizado Deflector',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM105 usa escudo específico. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Para corte MECANIZADO. Variante deflector del escudo mecanizado estándar.',
        kit: {}
      },
      '220992': {
        type: 'Escudo Manual 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este escudo es exclusivo del Powermax 105A legacy.',
        note_ok: 'Escudo MANUAL exclusivo para Powermax 105A.',
        kit: {}
      },
      '220993': {
        type: 'Escudo Mecanizado 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este escudo es exclusivo del Powermax 105A legacy.',
        note_ok: 'Escudo MECANIZADO exclusivo para Powermax 105A.',
        kit: {}
      },

      /* ── RETAINING CAPS ── */
      '220854': {
        type: 'Retaining Cap Standard',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa retaining cap exclusivo 220977. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Cap de retención estándar. Para mecanizado con sensado ohmic, usar 220953.',
        kit: {}
      },
      '220953': {
        type: 'Retaining Cap Ohmic (Mecanizado)',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa retaining cap ohmic exclusivo 420156. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Para sensado de altura OHMIC en mesas CNC mecanizado. Reemplaza al cap estándar 220854.',
        kit: {}
      },

      /* ── SWIRL RINGS ── */
      '220857': {
        type: 'Swirl Ring (Anillo Ciclónico)',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM105 usa swirl ring específico 220994. Los equipos SYNC usan cartuchos all-in-one.',
        note_ok: 'Anillo ciclónico estándar para familia Duramax 45-85A.',
        kit: {}
      },
      '220994': {
        type: 'Swirl Ring 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este swirl ring es exclusivo del Powermax 105A legacy.',
        note_ok: 'Anillo ciclónico exclusivo para Powermax 105A.',
        kit: {}
      },

      /* ── MARKING LEGACY (Duramax / Duramax Lock 45-105A) ── */
      /* Research OS F8 2026-04-28 — [VERIFIED] hypertherm.com + distribuidores autorizados */
      '420415': {
        type: 'Boquilla Marking 10-25A',
        note_ok: 'Para marcado/etiquetado CNC en plasma. Usar a 10-25A con escudo 420542 y electrodo 220842.',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa antorcha Duramax Hyamp (familia diferente). Los SYNC usan modo de marcado built-in con cartucho estándar — no requieren consumibles dedicados de marking.',
        kit: {}
      },
      '420542': {
        type: 'Escudo Marking 10-25A',
        note_ok: 'Escudo para marcado/etiquetado CNC en plasma. Usar con boquilla 420415 y electrodo 220842 a 10-25A.',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa antorcha Duramax Hyamp (familia diferente). Los SYNC usan modo de marcado built-in.',
        kit: {}
      },

      /* ── FINECUT MECANIZADO OHMIC ── */
      /* 220948 = variante con sensing ohmic. 220955 (ya en DB) = deflector sin ohmic. Son diferentes. */
      '220948': {
        type: 'Escudo FineCut Mecanizado Ohmic',
        note_ok: 'Escudo FineCut MECANIZADO con sensado OHMIC para control de altura THC en mesas CNC. Diferente al escudo 220955 que no tiene ohmic.',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa escudo mecanizado específico 220976. Los SYNC usan cartuchos all-in-one.',
        kit: {}
      },

      /* ── GOUGING MAX CONTROL LEGACY ── */
      '420480': {
        type: 'Escudo Gouging Max Control 26-105A',
        note_ok: 'Escudo de escarificado MAX CONTROL — remoción precisa y acabado limpio. Diferente al escudo 220798 (gouging estándar). Usar con boquilla 220797 (65-105A) o 420419 (45A).',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 usa consumibles Duramax Hyamp exclusivos. Los SYNC usan cartuchos all-in-one (428933/428939 para max control gouging).',
        kit: {}
      },
      '420419': {
        type: 'Boquilla Gouging Max Control 45A',
        note_ok: 'Boquilla de escarificado max control específica para 45A. Usar con escudo 420480 y electrodo 220842. Para 65A+ usar boquilla 220797.',
        pm45xp:'ok', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Boquilla exclusiva para 45A (Powermax 45XP). Para Powermax 65/85/105 usar boquilla 220797.',
        kit: {}
      },

      /* ── OHMIC RING SYNC INDIVIDUAL ── */
      '420580': {
        type: 'Anillo Ohmic SYNC (individual)',
        note_ok: 'Anillo ohmic individual para sensado de altura CNC en mecanizado SYNC. Viene en kit 428895 (3 pzas). También disponible por pieza.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El sensado ohmic SYNC es exclusivo de antorchas SmartSYNC. Para sistemas legacy usar retaining cap ohmic 220953 o 420156.',
        kit: {}
      },

      /* ── FINECUT ── */
      '220947': {
        type: 'Electrodo FineCut',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'FineCut legacy disponible para 45-105A (Duramax). PM125 usa Duramax Hyamp, no compatible. Los SYNC tienen cartuchos FineCut propios (428928/428926).',
        note_ok: 'Para corte FineCut en chapas delgadas (< 6mm). Usar con boquilla 220930 y escudo 220931.',
        kit: {}
      },
      '220930': {
        type: 'Boquilla FineCut',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'FineCut legacy disponible para 45-105A (Duramax). PM125 usa Duramax Hyamp, no compatible. Los SYNC tienen cartuchos FineCut propios.',
        note_ok: 'Boquilla FineCut para corte de alta precisión en chapas delgadas.',
        kit: {}
      },
      '220931': {
        type: 'Escudo FineCut',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'FineCut legacy disponible para 45-105A (Duramax). PM125 usa Duramax Hyamp, no compatible. Los SYNC tienen cartuchos FineCut propios.',
        note_ok: 'Escudo FineCut para corte de alta precisión en chapas delgadas.',
        kit: {}
      },

      /* ── GOUGING ── */
      '220797': {
        type: 'Boquilla Gouging',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Gouging legacy disponible para 45-85A. Los SYNC tienen cartuchos gouging propios (428932/428933).',
        note_ok: 'Para escarificado/gouging. Usar con escudo 220798.',
        kit: {}
      },
      '220798': {
        type: 'Escudo Gouging',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Gouging legacy disponible para 45-85A. Los SYNC tienen cartuchos gouging propios.',
        note_ok: 'Para escarificado/gouging. Usar con boquilla 220797.',
        kit: {}
      },

      /* ── CARTUCHOS SYNC ── */
      '428925': {
        type: 'Cartucho SYNC 45A Mecanizado',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El PM125 legacy (Duramax Hyamp) no acepta este cartucho.',
        note_ok: 'Cartucho SYNC all-in-one — auto-configura la máquina vía RFID.',
        kit: {}
      },
      '428927': {
        type: 'Cartucho SYNC 45A Manual (Drag)',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El PM125 legacy no acepta este cartucho.',
        note_ok: 'Cartucho SYNC all-in-one para corte manual (drag cutting).',
        kit: {}
      },
      '428930': {
        type: 'Cartucho SYNC 65A Mecanizado',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El PM45 SYNC es un equipo de 45A — no soporta cartuchos 65A. El PM125 legacy no acepta cartuchos SYNC.',
        note_ok: 'Cartucho SYNC 65A all-in-one para mecanizado CNC.',
        kit: {}
      },
      '428931': {
        type: 'Cartucho SYNC 65A Manual (Drag)',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El PM45 SYNC es un equipo de 45A — no soporta cartuchos 65A. El PM125 legacy no acepta cartuchos SYNC.',
        note_ok: 'Cartucho SYNC 65A all-in-one para corte manual.',
        kit: {}
      },
      '428934': {
        type: 'Cartucho SYNC 85A Mecanizado',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El PM45/65 SYNC no tienen suficiente potencia para cartuchos 85A. El PM125 legacy no acepta cartuchos SYNC.',
        note_ok: 'Cartucho SYNC 85A all-in-one para mecanizado CNC.',
        kit: {}
      },
      '428935': {
        type: 'Cartucho SYNC 85A Manual',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El PM45/65 SYNC no tienen suficiente potencia para cartuchos 85A. El PM125 legacy no acepta cartuchos SYNC.',
        note_ok: 'Cartucho SYNC 85A all-in-one para corte manual.',
        kit: {}
      },
      '428936': {
        type: 'Cartucho SYNC 105A Mecanizado',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'ok',
        no_reason: 'El cartucho 105A requiere al menos Powermax 105. No compatible con 45/65/85.',
        note_ok: 'Cartucho SYNC 105A para mecanizado CNC.',
        kit: {}
      },
      '428937': {
        type: 'Cartucho SYNC 105A Manual',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'ok',
        no_reason: 'El cartucho 105A requiere al menos Powermax 105. No compatible con 45/65/85.',
        note_ok: 'Cartucho SYNC 105A para corte manual.',
        kit: {}
      },
      '428928': {
        type: 'Cartucho SYNC FineCut Manual (30-45A)',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'FineCut 30-45A no disponible para PM125.',
        note_ok: 'Cartucho SYNC FineCut para corte de alta precisión en chapas delgadas.',
        kit: {}
      },
      '428926': {
        type: 'Cartucho SYNC FineCut Mecanizado (30-45A)',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'adapter', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'FineCut 30-45A no disponible para PM125.',
        note_ok: 'Cartucho SYNC FineCut para mecanizado de alta precisión.',
        kit: {}
      },
      '428932': {
        type: 'Cartucho SYNC Gouging Max-Removal 45-85A',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'no', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'Cartucho de 45-85A. Para PM105/125 usar 428938.',
        note_ok: 'Gouging de máxima remoción de material.',
        kit: {}
      },
      '428933': {
        type: 'Cartucho SYNC Gouging Max-Control 45-85A',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'no', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'Cartucho de 45-85A. Para PM105/125 usar 428939.',
        note_ok: 'Gouging de máximo control — acabado más limpio.',
        kit: {}
      },
      '428938': {
        type: 'Cartucho SYNC Gouging Max-Removal 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'ok',
        no_reason: 'Cartucho 105A — no compatible con 45/65/85.',
        note_ok: 'Gouging 105A de máxima remoción.',
        kit: {}
      },
      '428939': {
        type: 'Cartucho SYNC Gouging Max-Control 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'ok',
        no_reason: 'Cartucho 105A — no compatible con 45/65/85.',
        note_ok: 'Gouging 105A de máximo control.',
        kit: {}
      },
      '428952': {
        type: 'Cartucho SYNC FlushCut 65A',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'FlushCut 65A no compatible con PM45 SYNC (45A) ni PM125.',
        note_ok: 'Corte a ras de superficie — ideal para demolición y remodelación.',
        kit: {}
      },
      '428953': {
        type: 'Cartucho SYNC FlushCut 85A',
        pm45xp:'adapter', pm65:'adapter', pm85:'adapter', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'FlushCut 85A requiere PM85 o superior. No compatible con PM45/65 SYNC ni PM125.',
        note_ok: 'Corte a ras de superficie a 85A.',
        kit: {}
      },
      '428954': {
        type: 'Cartucho SYNC FlushCut 105A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'adapter', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'ok',
        no_reason: 'FlushCut 105A solo para PM105/125 SYNC.',
        note_ok: 'Corte a ras de superficie a 105A.',
        kit: {}
      },

      /* ── POWERMAX 125A (Duramax Hyamp — familia completamente independiente) ── */
      /* ⚠️ NINGÚN consumible es intercambiable con la familia 45-105A            */
      '220971': {
        type: 'Electrodo 125A',
        note_ok: '⚠️ Exclusivo Powermax 125A (Duramax Hyamp). NO intercambiable con el 220842 de 45-105A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este electrodo es exclusivo del Powermax 125A (familia Duramax Hyamp). Los SYNC usan cartuchos all-in-one.',
        kit: { manual: ['220975','420000','220977','220997'], mechanized: ['220975','420158','420169','220976','420168','220977','220997'] }
      },
      '220975': {
        type: 'Boquilla 125A',
        note_ok: 'Boquilla principal para corte manual y mecanizado en Powermax 125A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Boquilla exclusiva del Powermax 125A (familia Duramax Hyamp).',
        kit: {}
      },
      '420158': {
        type: 'Boquilla 125A Mecanizado V1',
        note_ok: 'Variante de boquilla para corte mecanizado CNC en Powermax 125A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Exclusiva Powermax 125A mecanizado.',
        kit: {}
      },
      '420169': {
        type: 'Boquilla 125A Mecanizado V2',
        note_ok: 'Segunda variante de boquilla para mecanizado CNC en Powermax 125A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Exclusiva Powermax 125A mecanizado.',
        kit: {}
      },
      '420000': {
        type: 'Escudo Manual 125A',
        note_ok: 'Escudo MANUAL exclusivo para Powermax 125A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este escudo es exclusivo del Powermax 125A.',
        kit: {}
      },
      '220976': {
        type: 'Escudo Mecanizado Standard 125A',
        note_ok: 'Escudo MECANIZADO estándar para Powermax 125A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este escudo es exclusivo del Powermax 125A.',
        kit: {}
      },
      '420168': {
        type: 'Escudo Mecanizado Deflector 125A',
        note_ok: 'Escudo mecanizado deflector para Powermax 125A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este escudo es exclusivo del Powermax 125A.',
        kit: {}
      },
      '220977': {
        type: 'Retaining Cap Standard 125A',
        note_ok: '⚠️ Exclusivo Powermax 125A. NO intercambiable con el 220854 de 45-105A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Esta retaining cap es exclusiva del Powermax 125A.',
        kit: {}
      },
      '420156': {
        type: 'Retaining Cap Ohmic 125A',
        note_ok: 'Para sensado OHMIC mecanizado en Powermax 125A. ⚠️ NO intercambiable con el 220953 de 45-105A.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Esta retaining cap ohmic es exclusiva del Powermax 125A.',
        kit: {}
      },
      '220997': {
        type: 'Swirl Ring 125A',
        note_ok: 'Anillo ciclónico exclusivo para Powermax 125A. ⚠️ Diferente al 220857/220994.',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'ok',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'Este swirl ring es exclusivo del Powermax 125A.',
        kit: {}
      },

      /* ── ADAPTADOR SYNC ── */
      '428951': {
        type: 'Adaptador Duramax → Cartucho SYNC',
        pm45xp:'ok', pm65:'ok', pm85:'ok', pm105:'ok', pm125:'no',
        pm45sync:'no', pm65sync:'no', pm85sync:'no', pm105sync:'no',
        no_reason: 'El PM125 legacy (Duramax Hyamp) no es compatible. Las máquinas SYNC nativas no requieren adaptador.',
        note_ok: 'Instala este adaptador en tu antorcha Duramax para usar cartuchos SYNC sin cambiar la máquina.',
        kit: {}
      },
      '428895': {
        type: 'Kit Anillo Ohmic SYNC (3 pzas)',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'ok', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'El sensado ohmic SYNC es exclusivo de torches SmartSYNC.',
        note_ok: 'Anillo ohmic para sensado de altura en mecanizado SYNC. Contiene 3 anillos #420580.',
        kit: {}
      },

      /* ── HYACCESS 65A — cartuchos de alcance extendido (PM65 SYNC y superiores) ── */
      '428984': {
        type: 'Cartucho SYNC HyAccess Drag 65A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'HyAccess 65A requiere mínimo PM65 SYNC. No disponible para PM45 SYNC ni PM125.',
        note_ok: 'Cartucho HyAccess de alcance extendido para acceso en espacios confinados — drag cutting 65A.',
        kit: {}
      },
      '428987': {
        type: 'Cartucho SYNC HyAccess Gouging 65A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'HyAccess 65A requiere mínimo PM65 SYNC. No disponible para PM45 SYNC ni PM125.',
        note_ok: 'Cartucho HyAccess de alcance extendido para gouging en espacios confinados — 65A.',
        kit: {}
      },
      '528079': {
        type: 'Cartucho SYNC HyAccess Mecanizado 65A',
        pm45xp:'no', pm65:'no', pm85:'no', pm105:'no', pm125:'no',
        pm45sync:'no', pm65sync:'ok', pm85sync:'ok', pm105sync:'ok',
        no_reason: 'HyAccess 65A requiere mínimo PM65 SYNC. No disponible para PM45 SYNC ni PM125.',
        note_ok: 'Cartucho HyAccess de alcance extendido para mecanizado CNC — torch largo 65A.',
        kit: {}
      }
    }
  };

  /* ============================================================
     ESTILOS INLINE DEL WIDGET (inyectados una sola vez)
  ============================================================ */
  var STYLES = [
    '.stnsr-card{border:1.5px solid #e0e0e0;border-radius:6px;padding:10px 8px;background:#fff;text-align:center;}',
    '.stnsr-card.ok{border-color:#34a853;cursor:pointer;}',
    '.stnsr-card.ok:hover{background:#f0faf3;}',
    '.stnsr-card.ok.active{background:#f0faf3;border-color:#1a5c2e;}',
    '.stnsr-card.adapter{border-color:#F57C00;cursor:pointer;}',
    '.stnsr-card.adapter:hover{background:#fff9e6;}',
    '.stnsr-card.adapter.active{background:#fff9e6;border-color:#7a4000;}',
    '.stnsr-card.no{opacity:0.42;cursor:default;}',
    '.stnsr-name{display:block;font-size:12px;font-weight:700;color:#1a1a1a;margin-bottom:6px;line-height:1.3;}',
    '.stnsr-badge{display:inline-block;border-radius:3px;padding:2px 7px;font-size:11px;font-weight:700;}',
    '.stnsr-badge.ok{background:#e8f5e9;color:#1a5c2e;}',
    '.stnsr-badge.adapter{background:#fff3e0;color:#7a4000;}',
    '.stnsr-badge.no{background:#f0f0f0;color:#888;}'
  ].join('');

  /* ============================================================
     findPartInSku — detecta número de parte dentro de un SKU codificado
     Ej: 'RAAEHT10-1050842' contiene '220842' NO — busca match exacto de 6 dígitos
  ============================================================ */
  function findPartInSku(sku) {
    if (!sku) return null;
    var parts = Object.keys(STANSER_COMPAT.parts);
    for (var i = 0; i < parts.length; i++) {
      if (sku.indexOf(parts[i]) !== -1) return parts[i];
    }
    return null;
  }

  /* ============================================================
     renderWidget — dibuja el widget para un número de parte dado
     Llamado al inicio y cada vez que cambia la variante
  ============================================================ */
  function renderWidget(partNumber) {
    var widget = document.getElementById('stanser-compat-widget');
    if (!widget) return;

    partNumber = (partNumber || '').trim();
    var partData = STANSER_COMPAT.parts[partNumber];

    // Reset: cerrar detalle y desactivar card previa
    _activeId = null;
    document.querySelectorAll('.stnsr-card.active').forEach(function(c) {
      c.classList.remove('active');
    });
    var panel = document.getElementById('stanser-detail-panel');
    if (panel) panel.style.display = 'none';

    // Actualizar etiqueta de tipo de parte
    var typeEl = document.getElementById('stanser-part-type');

    // Limpiar y reconstruir grids
    var legacyGrid = document.getElementById('stanser-grid-legacy');
    var syncGrid   = document.getElementById('stanser-grid-sync');
    if (legacyGrid) legacyGrid.innerHTML = '';
    if (syncGrid)   syncGrid.innerHTML = '';

    if (!partData) {
      if (typeEl) {
        if (partNumber) {
          typeEl.innerHTML = '<span style="color:#e53935;font-size:13px;">Parte <strong>#' + partNumber + '</strong> — no encontrada en base de datos. Verifica que el SKU del producto sea el número de parte Hypertherm.</span>';
        } else {
          typeEl.textContent = 'Selecciona una variante para ver la compatibilidad.';
        }
      }
      if (legacyGrid) legacyGrid.innerHTML =
        '<p style="color:#bbb;font-size:13px;grid-column:1/-1;padding:4px 0 12px;">—</p>';
      return;
    }

    // Contar máquinas compatibles para badge de exclusividad
    var okMachines = [];
    Object.keys(STANSER_COMPAT.machines).forEach(function(k) {
      if (partData[k] === 'ok' || partData[k] === 'adapter') {
        okMachines.push(STANSER_COMPAT.machines[k].short);
      }
    });

    if (typeEl) {
      var baseText = 'Parte <strong>#' + partNumber + '</strong> — ' + partData.type;
      if (okMachines.length === 1) {
        // Parte exclusiva de 1 sola máquina (ej: boquilla PM125, boquilla PM105)
        typeEl.innerHTML = baseText +
          '&nbsp;&nbsp;<span style="background:#34a853;color:#fff;border-radius:4px;padding:3px 10px;font-size:11px;font-weight:700;white-space:nowrap;">✓ Exclusivo ' + okMachines[0] + '</span>';
      } else if (okMachines.length === 0) {
        typeEl.innerHTML = baseText + '&nbsp;<span style="color:#e53935;font-size:12px;">(sin modelos compatibles registrados)</span>';
      } else {
        typeEl.innerHTML = baseText + '&nbsp;<span style="color:#666;font-size:12px;">· ' + okMachines.length + ' modelos compatibles</span>';
      }
    }

    buildGrid('legacy', 'stanser-grid-legacy', partNumber, partData);
    buildGrid('sync',   'stanser-grid-sync',   partNumber, partData);
  }

  /* ============================================================
     INICIALIZACIÓN + LISTENERS DE VARIANTE
  ============================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    var widget = document.getElementById('stanser-compat-widget');
    if (!widget) return;

    // Inyectar estilos una sola vez
    if (!document.getElementById('stnsr-compat-css')) {
      var styleEl = document.createElement('style');
      styleEl.id  = 'stnsr-compat-css';
      styleEl.textContent = STYLES;
      document.head.appendChild(styleEl);
    }

    // Render inicial
    var initialPart = (widget.getAttribute('data-part') || '').trim();
    if (initialPart && !STANSER_COMPAT.parts[initialPart]) {
      initialPart = findPartInSku(initialPart) || initialPart;
    }
    renderWidget(initialPart);

    // ── Reactividad a cambio de variante ──────────────────────
    var variantSkusRaw = widget.getAttribute('data-variant-skus') || '{}';
    var variantSkus = {};
    try { variantSkus = JSON.parse(variantSkusRaw); } catch(e) {}

    // Si solo hay 1 variante (o 0), no hace falta escuchar cambios
    if (Object.keys(variantSkus).length <= 1) return;

    function handleVariantId(vid) {
      var sku  = variantSkus[String(vid)] || '';
      var part = findPartInSku(sku) || '';
      var current = (widget.getAttribute('data-part') || '').trim();
      if (part !== current) {
        widget.setAttribute('data-part', part);
        renderWidget(part);
      }
    }

    // Método 1: evento 'variant:changed' (Warehouse theme y otros temas modernos)
    document.addEventListener('variant:changed', function(e) {
      var v = (e.detail || {}).variant || {};
      if (v.id) handleVariantId(v.id);
    });

    // Método 2: change en input[name="id"] — fallback Warehouse / Dawn
    document.addEventListener('change', function(e) {
      var el = e.target;
      if (el && el.name === 'id') handleVariantId(el.value);
    });

    // Método 3: polling del parámetro ?variant= en la URL (máxima compatibilidad)
    var lastVid = new URLSearchParams(window.location.search).get('variant');
    setInterval(function() {
      var vid = new URLSearchParams(window.location.search).get('variant');
      if (vid && vid !== lastVid) {
        lastVid = vid;
        handleVariantId(vid);
      }
    }, 400);
  });

  /* ============================================================
     buildGrid — crea las cards de todas las máquinas de una serie
  ============================================================ */
  function buildGrid(series, containerId, partNumber, partData) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var BADGE_LABEL = { ok: '✓ Compatible', adapter: '⚙ Adaptador', no: '✕ No compatible' };

    Object.keys(STANSER_COMPAT.machines).forEach(function(machineId) {
      var m = STANSER_COMPAT.machines[machineId];
      if (m.series !== series) return;

      var status = partData ? (partData[machineId] || 'no') : 'no';

      var card = document.createElement('div');
      card.className = 'stnsr-card ' + status;
      card.id = 'stnsr-card-' + machineId;
      card.innerHTML =
        '<span class="stnsr-name">' + m.short + '</span>' +
        '<span class="stnsr-badge ' + status + '">' + BADGE_LABEL[status] + '</span>';

      if (status === 'ok' || status === 'adapter') {
        card.addEventListener('click', (function(mid, mdata, st, pd) {
          return function() { toggleDetail(mid, mdata, st, pd); };
        })(machineId, m, status, partData));
      }

      container.appendChild(card);
    });
  }

  /* ============================================================
     toggleDetail — muestra/oculta el panel de detalle
  ============================================================ */
  var _activeId = null;

  function toggleDetail(machineId, m, status, partData) {
    var panel = document.getElementById('stanser-detail-panel');
    if (!panel) return;

    // Desactivar card previa
    document.querySelectorAll('.stnsr-card.active').forEach(function(c) {
      c.classList.remove('active');
    });

    // Cerrar si se clickea la misma card
    if (_activeId === machineId) {
      panel.style.display = 'none';
      _activeId = null;
      return;
    }

    _activeId = machineId;
    document.getElementById('stnsr-card-' + machineId).classList.add('active');

    // Construir contenido del panel
    var borderColor = status === 'adapter' ? '#F57C00' : '#34a853';
    var bgColor     = status === 'adapter' ? '#fff9e6' : '#f0faf3';

    var noteOk = partData && partData.note_ok ? partData.note_ok : '';

    var adapterHtml = '';
    if (status === 'adapter') {
      adapterHtml =
        '<p style="margin:10px 0 0;font-size:12px;color:#7a4000;background:#fff3e0;border-radius:4px;padding:8px 10px;">' +
        'Requiere adaptador <strong>428951</strong> para instalar cartucho SYNC en antorcha Duramax legacy.' +
        '</p>';
    }

    var siblingsHtml = renderSiblings(partData, machineId);

    panel.style.cssText =
      'display:block;border:1.5px solid ' + borderColor + ';border-radius:6px;' +
      'padding:14px 16px;margin-bottom:16px;background:' + bgColor + ';';

    panel.innerHTML =
      '<p style="margin:0 0 12px;font-size:13px;font-weight:700;color:#1a1a1a;">' + m.name + '</p>' +
      (noteOk ? '<p style="margin:0 0 12px;font-size:12px;color:#555;">' + noteOk + '</p>' : '') +
      '<table style="width:100%;border-collapse:collapse;font-size:13px;">' +
        '<tbody>' +
          '<tr>' +
            '<td style="padding:7px 10px;border:1px solid #b2d8b2;background:#e8f5e9;font-weight:700;color:#1a5c2e;width:55%;">Corte mecanizado CNC (pierce)</td>' +
            '<td style="padding:7px 10px;border:1px solid #b2d8b2;background:#e8f5e9;font-weight:800;color:#1a5c2e;font-size:15px;">' + m.pierce + ' mm</td>' +
          '</tr>' +
          '<tr>' +
            '<td style="padding:6px 10px;border:1px solid #e0e0e0;background:#f9f9f9;font-weight:600;color:#555;">Corte desde la orilla</td>' +
            '<td style="padding:6px 10px;border:1px solid #e0e0e0;background:#f9f9f9;font-weight:700;color:#1a1a1a;">' + m.rec + ' mm</td>' +
          '</tr>' +
        '</tbody>' +
      '</table>' +
      adapterHtml +
      siblingsHtml;
  }

  /* ============================================================
     renderSiblings — kit de consumibles complementarios
  ============================================================ */
  function renderSiblings(partData, machineId) {
    if (!partData || !partData.kit) return '';

    var allParts = {};
    ['manual', 'mechanized'].forEach(function(mode) {
      var parts = partData.kit[mode] || [];
      parts.forEach(function(p) { allParts[p] = true; });
    });

    var partKeys = Object.keys(allParts);
    if (partKeys.length === 0) return '';

    var chips = partKeys.map(function(p) {
      var pd = STANSER_COMPAT.parts[p];
      var label = pd ? pd.type : p;
      return '<span style="display:inline-block;padding:5px 10px;background:#f0f0f0;border-radius:4px;font-size:12px;color:#1a1a1a;border:1px solid #ddd;">' +
        p + ' — ' + label + '</span>';
    }).join('');

    return '<div style="margin-top:12px;">' +
      '<p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#1a1a1a;">Completa el kit:</p>' +
      '<div style="display:flex;flex-wrap:wrap;gap:6px;">' + chips + '</div>' +
      '</div>';
  }

})();
